var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('ok-modal'),_c('confirm-modal'),_c('spinner',{attrs:{"image":"/images/landing/spinner.png"}}),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }